/* sb-dc-catclean.js - keep the category list to things a customer would
   click. 2026-09-12.

   Reported (feedback item 14): the sidebar shows internal categories
   ("Uploads", "Custom Banners", "Best Sellers") and, on retractable banners,
   categories holding a single design - "Graduation 1", "Sports 1",
   "Holiday 1". Neither is worth a click.

   MEASURED (live, ?product=pop-up-retractable-banner): #sbdt-cats is a <ul>
   of <li data-cat="...">Name<span class="cnt">N</span></li>, and that product
   really does show Graduation 1, Sports 1, Holiday 1 and Custom Banners 2.

   TWO RULES:
     INTERNAL  a name on the list below is always hidden. These are ours, not
               the customer's - "Uploads" is where new artwork lands and
               "Custom Banners" is a working bucket.
     THIN      fewer than MIN_COUNT designs is hidden too. One design is not a
               category; the design is still reachable under All Templates,
               which is never hidden.

   The counts change with the product, so a category hidden on retractables
   can be there on vinyl banners. That is the point - the list follows what is
   actually behind it.

   SAFETY: if the rules would leave nothing but All Templates, nothing is
   hidden. An empty sidebar looks broken, and a thin list is better than that.
   Also, a hidden category that happens to be the SELECTED one is left alone,
   so nobody ends up looking at a filter they cannot see or clear.

   Display only. The categories still exist, the data is untouched, and
   removing this file puts the list back.

   Diagnostics: window.__dcCatClean() */
(function () {
  'use strict';

  var INTERNAL = /^(uploads|custom banners|best sellers|test|misc|temp|internal)\b/i;
  var MIN_COUNT = 2;
  var DEBOUNCE = 150;

  var info = { hidden: [], kept: 0, passes: 0, skipped: '' };
  window.__dcCatClean = function () { return info; };

  function list() { return document.getElementById('sbdt-cats'); }

  function parse(li) {
    var cnt = li.querySelector('.cnt');
    var n = cnt ? parseInt((cnt.textContent || '').replace(/\D/g, ''), 10) : NaN;
    var name = (li.textContent || '').replace(/\s+/g, ' ').trim();
    if (cnt) name = name.replace(/\s*\d+$/, '').trim();
    return { name: name, count: isNaN(n) ? null : n, cat: li.getAttribute('data-cat') || '' };
  }

  var obs = null;
  function sweep() {
    var ul = list();
    if (!ul) return;
    info.passes++;

    var items = Array.prototype.slice.call(ul.children);
    var drop = [], keep = 0;

    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      var d = parse(li);
      if (d.cat === 'all') { keep++; continue; }              // never touched
      if (li.classList.contains('is-on')) { keep++; continue; } // the active filter
      var thin = d.count !== null && d.count < MIN_COUNT;
      if (INTERNAL.test(d.name) || thin) drop.push({ li: li, name: d.name, count: d.count });
      else keep++;
    }

    if (!keep || keep < 2) {            // would leave just "All" - leave it be
      info.skipped = 'too few categories left';
      for (var k = 0; k < items.length; k++) items[k].style.removeProperty('display');
      return;
    }
    info.skipped = '';

    if (obs) obs.disconnect();
    for (var j = 0; j < drop.length; j++) {
      if (drop[j].li.style.display !== 'none') drop[j].li.style.display = 'none';
      var label = drop[j].name + (drop[j].count === null ? '' : ' (' + drop[j].count + ')');
      if (info.hidden.indexOf(label) < 0) info.hidden.push(label);
    }
    info.kept = keep;
    watch();
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; sweep(); }, DEBOUNCE);
  }

  function watch() {
    var ul = list();
    if (!ul) return;
    if (!obs) obs = new MutationObserver(schedule);
    obs.observe(ul, { childList: true, subtree: true, characterData: true });
  }

  function start() {
    sweep();
    watch();
    setInterval(function () { sweep(); watch(); }, 2000);   // the list is rebuilt per product
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
